var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/toggle/star_24px",
    d: "M9.99935 14.3915L15.1494 17.4998L13.7827 11.6415L18.3327 7.69984L12.341 7.1915L9.99935 1.6665L7.65768 7.1915L1.66602 7.69984L6.21602 11.6415L4.84935 17.4998L9.99935 14.3915Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0153b40cac39047c37dd6efc246c095b.svg";
export { ForwardRef as ReactComponent };